import React from 'react';
import { ProcessForm } from '../ovz-facility-request-operator-change-types';

export function StepNewOperatorLabel({
  allValues,
}: {
  allValues?: ProcessForm;
}) {
  return (
    <>
      Nový provozovatel: <b>{allValues?.newOperatorIdentifier}</b>
    </>
  );
}
